// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3n7xU","controls":"styles_controls__bz_kB","charLimit":"styles_charLimit__3c8Tx","input":"styles_input__2BFQk","send":"styles_send__2omKr"};